import { isMobileScreen, setPageTitle } from "../common";
import ShopNavigationPanel from "./extra/ShopNavigationPanel";

function PrivacyPolicy() {
  setPageTitle("Privacy Policy | Your Data Protection & Privacy Rights");
  return (
    <>
      <section
        className="breadcrumbs-custom"
        data-preset='{"title":"Breadcrumbs","category":"header","reload":false,"id":"breadcrumbs"}'
      >
        <div className="breadcrumbs-custom-container">
          <ul className="breadcrumbs-custom-path">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <span className="">Privacy Policy</span>
            </li>
          </ul>
        </div>
      </section>
      <section
        className={isMobileScreen() ? "bg-white" : "section-sm bg-white"}
      >
        <div className="container-xl">
          <div className="row row-40">
            {isMobileScreen() ? (
              <></>
            ) : (
              <div className="col-md-2">
                <ShopNavigationPanel />
              </div>
            )}
            <div className="col-md-10">
              <div className="container">
                <h1 className="h3 font-weight-bold mt-2">Privacy Policy</h1>
                <div className="body-1">
                  Your privacy is important to us. This Privacy Policy explains
                  how we collect, use, disclose, and safeguard your information
                  when you visit our website and use our services. By accessing
                  or using our site, you agree to the terms of this policy.
                </div>

                <section className="mb-4 mt-4">
                  <h2 className="h4 section-title mb-2">
                    Information We Collect
                  </h2>
                  <div className="body-1 mb-2">
                    <div>
                      Personal Information: Name, email address, shipping
                      address, phone number, payment information, and other
                      details you provide when placing an order or creating an
                      account.
                    </div>
                    <div>
                      Non-Personal Information: Browser type, device
                      information, IP address, and usage data collected
                      automatically when you interact with our site.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    How We Use Your Information
                  </h2>
                  <div className="body-1 mb-2">
                    <div>To process and fulfill your orders.</div>
                    <div>
                      To communicate with you about your account or orders.
                    </div>
                    <div>To improve our website, products, and services.</div>
                    <div>
                      To send promotional emails or marketing communications
                      (you may opt out at any time).
                    </div>
                    <div>
                      To comply with legal obligations and prevent fraud.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    How We Share Your Information
                  </h2>
                  <div className="body-1 mb-2">
                    <div>We do not sell your personal information.</div>
                    <div>
                      We may share your information with trusted third parties
                      who assist us in operating our website, conducting our
                      business, or servicing you, so long as those parties agree
                      to keep this information confidential.
                    </div>
                    <div>
                      We may also release information when required by law, to
                      enforce our site policies, or protect ours or others'
                      rights, property, or safety.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    Cookies & Tracking Technologies
                  </h2>
                  <div className="body-1 mb-2">
                    <div>
                      We use cookies and similar technologies to enhance your
                      experience, analyze site usage, and assist in our
                      marketing efforts.
                    </div>
                    <div>
                      You can choose to disable cookies through your browser
                      settings, but this may affect your ability to use certain
                      features of our site.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Data Security</h2>
                  <div className="body-1">
                    We implement a variety of security measures to maintain the
                    safety of your personal information. However, no method of
                    transmission over the Internet or electronic storage is 100%
                    secure, and we cannot guarantee absolute security.
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Children's Privacy</h2>
                  <div className="body-1">
                    Our website is not intended for children under 21. We do not
                    knowingly collect or solicit information from anyone under
                    the age of 21. If you believe we have collected such
                    information, please contact us to have it removed.
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Your Choices</h2>
                  <div className="body-1 mb-2">
                    <div>
                      You may review, update, or delete your personal
                      information by contacting our support team.
                    </div>
                    <div>
                      You may opt out of marketing emails at any time by
                      following the unsubscribe instructions in those emails.
                    </div>
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">
                    Changes to This Policy
                  </h2>
                  <div className="body-1">
                    We may update this Privacy Policy from time to time. Changes
                    will be posted on this page with an updated effective date.
                    Your continued use of the site after any changes constitutes
                    your acceptance of the new policy.
                  </div>
                </section>

                <section className="mb-4">
                  <h2 className="h4 section-title mb-2">Contact Us</h2>
                  <div className="body-1">
                    If you have any questions or concerns about this Privacy
                    Policy or our data practices, please contact us at{" "}
                    <strong>{process.env.REACT_APP_SUPPORT_EMAIL}</strong>.
                  </div>
                </section>

                <footer className="mt-5">
                  <div className="font-weight-bold small">
                    *This is an auto-generated policy. Please contact support
                    for any questions.
                  </div>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;
